export default [
  { methods: ["POST"], uri: "api/v1/forms/send", name: "forms.records.send" },
];
